import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './BehaviorVideo.module.scss';

interface StopConnectionButtonProps {
    className?: string;
    title?: string;
    buttonText?: string;
    onStop: () => void;
}

export function StopConnectionButton(props: StopConnectionButtonProps) {
    const { t } = useTranslation('behaviorModule');
    const defaultTitle = t('videoStream.stopConnection', 'Stop connection');
    const defaultButtonText = t('videoStream.stopConnection', 'Stop connection');
    const { className, title = defaultTitle, buttonText = defaultButtonText, onStop } = props;

    return (
        <button
            type="button"
            onClick={onStop}
            className={cn(styles.stopButton, className)}
            title={title}>
            {buttonText}
        </button>
    );
}
